module.exports = __webpack_public_path__ + "static/media/galerija_2021 (22)-min.30bca5fc.jpg";